export function clearSessionStorage() {
    window.sessionStorage.removeItem('fields');
    window.sessionStorage.removeItem('currentSectionIndex');
    window.sessionStorage.removeItem('startTime');
}
